import { createAction } from '/@/store/utils';

export const setSoilTextures = createAction('CARBON_CALCULATOR:SET_SOIL_TEXTURES');
export const setSoilTexturesOptions = createAction('CARBON_CALCULATOR:SET_SOIL_TEXTURES_OPTIONS');
export const setSelectedSoilTexture = createAction('CARBON_CALCULATOR:SET_SELECTED_SOIL_TEXTURES');
export const setCrops = createAction('CARBON_CALCULATOR:SET_CROPS');
export const setCropRotation = createAction('CARBON_CALCULATOR:SET_CROP_ROTATION');
export const setSelectedCropRotation = createAction('CARBON_CALCULATOR:SET_CROP_ROTATION');
export const setAgriculturalPractice = createAction('CARBON_CALCULATOR:SET_AGRICULTURAL_PRACTICE');
export const setAgriculturalPracticeOptions = createAction('CARBON_CALCULATOR:SET_AGRICULTURAL_PRACTICE_OPTIONS');
